import * as React from 'react';

var _mask, _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgBr = function SvgBr(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_5422_28850)"
    }, _mask || (_mask = /*#__PURE__*/ React.createElement("mask", {
        id: "path-1-outside-1_5422_28850",
        width: 20,
        height: 16,
        x: 2.4,
        y: 4.8,
        fill: "#000",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M2.4 4.8h20v16h-20z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2.4 5.8a1 1 0 0 1 1-1h17.2a1 1 0 0 1 1 1v12.4a1 1 0 0 1-1 1H3.4a1 1 0 0 1-1-1z"
    }))), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_5422_28850",
        width: 20,
        height: 16,
        x: 2,
        y: 4,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M2.4 4.8h19.2v14.4H2.4z"
    }))), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_5422_28850)"
    }, _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#093",
        fillRule: "evenodd",
        d: "M2.4 4.8v14.4h19.2V4.8z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("mask", {
        id: "mask1_5422_28850",
        width: 20,
        height: 16,
        x: 2,
        y: 4,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M2.4 4.8v14.4h19.2V4.8z",
        clipRule: "evenodd"
    }))), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask1_5422_28850)"
    }, _g || (_g = /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        filter: "url(#filter0_d_5422_28850)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFD221",
        d: "m11.957 7.022 7.32 5.102-7.42 4.779-7.171-4.878z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_5422_28850)",
        d: "m11.957 7.022 7.32 5.102-7.42 4.779-7.171-4.878z"
    }))), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#2E42A5",
        fillRule: "evenodd",
        d: "M12 15.12a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("mask", {
        id: "mask2_5422_28850",
        width: 6,
        height: 7,
        x: 9,
        y: 9,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M12 15.12a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
        clipRule: "evenodd"
    }))), _g2 || (_g2 = /*#__PURE__*/ React.createElement("g", {
        fill: "#F7FCFF",
        mask: "url(#mask2_5422_28850)"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "m11.029 13.542-.134.07.025-.15-.108-.105.15-.021.067-.136.067.136.15.021-.109.106.026.15zM12.228 13.542l-.134.07.026-.15-.109-.105.15-.021.067-.136.067.136.15.021-.109.106.026.15zM12.228 14.262l-.134.07.026-.149-.109-.105.15-.022.067-.136.067.136.15.022-.109.105.026.15zM11.628 11.742l-.134.07.026-.149-.108-.106.15-.021.066-.136.067.136.15.021-.108.106.025.15zM11.628 12.942l-.134.07.026-.15-.108-.105.15-.022.066-.135.067.135.15.022-.108.106.025.15zM10.789 12.342l-.134.07.025-.149-.108-.105.15-.022.067-.136.067.136.15.022-.109.105.026.15zM9.949 12.822l-.134.07.025-.149-.108-.106.15-.021.067-.136.067.136.15.021-.109.106.026.15zM12.709 10.782l-.134.07.025-.149-.108-.105.15-.022.067-.136.066.136.15.021-.108.106.025.15z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m8.355 11.398.09-1.196c2.88.217 5.152 1.163 6.788 2.847l-.86.837c-1.419-1.46-3.415-2.291-6.018-2.488"
    })))))), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "#111827",
        fillOpacity: 0.1,
        d: "M2.4 4.8h19.2zm19.2 13.4a2 2 0 0 1-2 2H4.4a2 2 0 0 1-2-2h19.2m-19.2 1V4.8zM21.6 4.8v14.4z",
        mask: "url(#path-1-outside-1_5422_28850)"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_5422_28850",
        x1: 21.6,
        x2: 21.6,
        y1: 19.2,
        y2: 4.8,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFC600"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFDE42"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_5422_28850"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M2.4 5.8a1 1 0 0 1 1-1h17.2a1 1 0 0 1 1 1v12.4a1 1 0 0 1-1 1H3.4a1 1 0 0 1-1-1z"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "filter0_d_5422_28850",
        width: 14.592,
        height: 9.88,
        x: 4.686,
        y: 7.022,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", null), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0.0313726 0 0 0 0 0.368627 0 0 0 0 0 0 0 0 0.28 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_5422_28850"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_5422_28850",
        result: "shape"
    })))));
};

export { SvgBr as ReactComponent };
//# sourceMappingURL=BR.svg.es.js.map
